import { columns, drawerFilters } from './helpers'
import { useState } from 'react'
import { toTableRowItems } from './serializers'
import { makeCoreGetRequest } from 'utils/api'
import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { EditActionIcon } from 'icons'
import EditStore from './EditStore/EditStore'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import {
  getDepositOptions,
  getHubOptions,
  getShopOptions
} from 'components/shop-reception/admin/api'

const CentralizeHubs = ({ permissions }) => {
  const { showNotification } = useNotification()
  const [tableItems, setTableItems] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const [selectedRow, setSelectedRow] = useState<DLCProducts>()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const openUpdateModal = () => setIsOpen(true)
  const closeUpdateModal = () => setIsOpen(false)

  const selectRow = (rowId: number | string) => {
    const row = tableItems.find(item => item.id === rowId)
    if (row) setSelectedRow(row)
  }

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: '/shop-reception/delivery-matrix/hubs',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const { data: shopCodes } = getShopOptions(showNotification)

  const { data: depositOptions } = getDepositOptions(showNotification)

  const { data: hubsOptions } = getHubOptions(showNotification)

  return (
    <>
      <EditStore
        isOpen={isOpen}
        closeModal={closeUpdateModal}
        setShouldRefreshData={setShouldRefreshData}
        editItem={selectedRow}
      />

      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActions={permissions?.canEdit ? [
          {
            label: 'Afiseaza',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#16a085',
            desktopIcon: <EditActionIcon />,
            onClick: (e, rowId) => {
              selectRow(rowId)
              openUpdateModal()
            }
          }
        ] : []}
        rowActionsWidth="130px"
        filters={drawerFilters(shopCodes, depositOptions, hubsOptions)}
        filtersButtonLabel="Filtre"
        filtersLabel="Filtre"
        appliedFiltersLabel="Filtre aplicate"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </>
  )
}

export default CentralizeHubs
